import { useMemo, useEffect } from 'react';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import { getSubsInDelimeters, downloadFile, downloadFromUrl } from 'granite-admin/utils/functions';
function useUtility(args) {
  const {
    grandListner
  } = args || {};
  const grandEmitter = useMemo(() => getGrandEmitter(), []);

  // const showToast = useCallback(
  //   (msg, status) => {
  //     grandEmitter.emit('SHOW_TOAST', { message: msg, status });
  //   },
  //   [grandEmitter],
  // );

  useEffect(() => {
    const subsribers = typeof grandListner === 'function' ? grandListner : function () {};
    const subscription = grandEmitter.getObservable().subscribe(subsribers);
    return () => subscription.unsubscribe();
  }, [grandEmitter, grandListner]);
  return {
    grandEmitter,
    getSubsInDelimeters,
    downloadFile,
    downloadFromUrl
  };
}
export default useUtility;